import { Injectable, Provider } from '@angular/core';
import { MatSortHeaderIntl } from '@angular/material/sort';

@Injectable({
  providedIn: 'root'
})
export class MatSortHeaderService extends MatSortHeaderIntl {

  sortButtonLabel = (_id: string) => null;

}

export const matSortHeaderProvider: Provider = {
  provide: MatSortHeaderIntl,
  useValue: new MatSortHeaderService()
};
